<script lang="ts">
	//Formating
	import { format } from 'svelte-i18n';
	// Design system components
	import {
		Alert,
		Button,
		Modal,
		Text,
		Wizard,
		WizardContainer,
		WizardContent,
		WizardItem,
		Container,
	} from '@Shelly/shelly-design-system';
	import { PV_SETUP_IMG_FOLDER, pvSetUpWizardItems } from './pv_setup_info_helper';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let showModal: boolean;

	const onClickWizardItem = (e, index: number) => {
		wizardItems = wizardItems.map((item, i) => {
			if (i === index) {
				activeStep = {
					...item,
					activeIndex: i,
				};

				return {
					...item,
					active: true,
				};
			}
			return {
				...item,
				active: false,
			};
		});
	};

	const onCloseWizard = () => {
		showModal = false;
	};

	let wizardItems = pvSetUpWizardItems;
	let activeStep = wizardItems[0];
</script>

<Modal
	{showModal}
	on:close={onCloseWizard}
	title={$format('pv_setup_info_modal_title', { default: 'PV Setup Info' })}
>
	<Wizard slot="toolbar">
		{#each wizardItems as item, i (i)}
			<WizardItem
				on:click={(e) => {
					onClickWizardItem(e, i);
				}}
				active={item.active}
				title={$format(item.titleKey, { default: item.title })}
				disabled={item.disabled}
				showMoreDots={item.showMoreDots}
				indicatorColor={$showNewLayout ? 'color-2' : undefined}
			/>
		{/each}
	</Wizard>

	<div slot="content">
		<WizardContainer activeStepIndex={activeStep.activeIndex} adaptiveHeight>
			{#each wizardItems as item, i (i)}
				<WizardContent active={activeStep.activeIndex === i}>
					<Text styleType="h2">
						{$format(item.subtitleKey, { default: item.subtitle })}
					</Text>
					<hr class="mt-m mb-l" />
					<Container type="borderSolid" class="mb-m">
						{#if item.bullets}
							{#each item.bullets as bullet}
								<Text
									styleType="body-small"
									class={'mb-m' + (bullet.style ? ' ' + bullet.style : '')}
								>
									{$format(bullet.key, { default: bullet.default })}
								</Text>
							{/each}
							<div class="d-flex justify-content-center flex-wrap mt-xl mb-l">
								{#each item.images as image}
									<div
										class={(image.class ? image.class + ' ' : '') +
											'd-flex justify-content-center flex-direction-column'}
									>
										<img
											src={PV_SETUP_IMG_FOLDER + image.src + '.png'}
											alt={$format(item.subtitleKey, { default: item.subtitle })}
										/>
										{#if image.title}
											<Text styleType="body" class="mt-m text-center">
												{$format(image.title.key, {
													default: image.title.default,
												})}
											</Text>
										{/if}
									</div>
								{/each}
							</div>
						{/if}
						{#if i === 0}
							<Alert
								heading={$format('pv_setup_info_modal_modes_alert', {
									default:
										'Small differences between values are expected. Inverters naturally lose some energy as heat and during conversion.',
								})}
							/>
						{/if}
					</Container>
				</WizardContent>
			{/each}
		</WizardContainer>
		<div class="d-flex justify-content-end">
			{#if activeStep.activeIndex >= 1}
				<Button
					class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
					variant="secondary"
					responsiveSize={{
						sm: 'm',
					}}
					on:click={() => {
						onClickWizardItem(null, activeStep.activeIndex - 1);
					}}
				>
					{$format('button_back', { default: 'Back' })}
				</Button>
			{/if}
			<Button
				id="pvsetupWizardNextButton"
				aria-labelledby="pvsetupWizardNextButton"
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
				responsiveSize={{
					sm: 'm',
				}}
				on:click={() => {
					if (activeStep.activeIndex < wizardItems.length - 1) {
						onClickWizardItem(null, activeStep.activeIndex + 1);
					} else {
						onCloseWizard();
					}
				}}
			>
				{#if activeStep.activeIndex < wizardItems.length - 1}
					{$format('button_next', { default: 'Next' })}
				{:else}
					{$format('button_close', { default: 'Close' })}
				{/if}
			</Button>
		</div>
	</div></Modal
>

<style>
	:global(.text-italic) {
		font-style: italic;
	}
	.image-wrapper {
		padding: 20px 40px;
	}
	img {
		max-width: 100%;
	}
</style>
